import type { BackendRouteDefinition } from '../types';

export const getEmployeeRegistrationPageRoute = {
  transport: 'api',
  method: 'GET',
  path: '/public/employee-registration-pages/:registrationPageId',
  params: ({ registrationPageId }: { registrationPageId: string }) => ({
    registrationPageId,
  }),
} as const satisfies BackendRouteDefinition;
